import { BASIS_CATEGORY_DEF_NAMES, IBasisParamterDef, IQualificationBasisDef } from 'src/app/model/view/iqualification-basis-def';
import { OrientationDefinitions } from './orientation-definitions';

export class BasisDefinitions {

    /**
     * Will return a list of valid qualification basis definitions sorted by name.
     * @param param context parameters
     * @param definitions creator functions for bases
     */
    public static buildBases(param: IBasisParamterDef, ...definitions: ((param: IBasisParamterDef) => IQualificationBasisDef)[])
        : IQualificationBasisDef[] {
        return definitions
            .map((fun) => fun(param))
            .filter((def) => def !== null)
            .sort((a, b) => a.typeName.localeCompare(b.typeName));
    }

    public static MIN_YEARS_EXPERIENCE(param: IBasisParamterDef): IQualificationBasisDef {
        // LLEG-817: 4 years are required for persons born before 1958-07-01, from 2022-08-31 it is impossible to apply 8 years experience.
        const cutoff = new Date(1958, 7, 1);
        if (cutoff > param.dateOfBirth) {
            return {
                typeCode: 'MIN_4_YEARS_EXPERIENCE',
                typeName: 'Jag har minst fyra års undervisningserfarenhet i ämnet/skolformen',
                yearFreeMax: param.maxToYear,
                yearIntervals: null,
            };
        } else {
            return null;
        }
    }

    public static RELEVANT_COMPETENCE(param: IBasisParamterDef): IQualificationBasisDef {
        const valid = param.category === BASIS_CATEGORY_DEF_NAMES.OTHER;
        return valid ? {
            typeCode: 'RELEVANT_COMPETENCE',
            typeName: 'Jag har fullgjort högskoleutbildning och/eller har relevant kompetens',
            yearFreeMax: null,
            yearIntervals: null,
        } : null;
    }

    public static COMPLETED_HIGHER_EDUCATION(param: IBasisParamterDef): IQualificationBasisDef {
        const valid = param.category !== BASIS_CATEGORY_DEF_NAMES.VOCATIONAL
            && param.category !== BASIS_CATEGORY_DEF_NAMES.OTHER
            && [
                undefined,
                OrientationDefinitions.DEF_OR_IMP_HEARING().code,
                OrientationDefinitions.SEVERE_LANG_DISORDER().code,
            ].indexOf(param.orientation) > -1;
        return valid ? {
            typeCode: 'COMPLETED_HIGHER_EDUCATION',
            typeName: 'Jag har genomfört ämnesstudier på högskolenivå',
            yearFreeMax: null,
            yearIntervals: BasisDefinitions.buildYearIntervals(param.maxToYear),
        } : null;
    }

    public static VOCATIONAL_SKILLS_NOT_BY_TEACHING(param: IBasisParamterDef): IQualificationBasisDef {
        const valid = param.category === BASIS_CATEGORY_DEF_NAMES.VOCATIONAL;
        return valid ? {
            typeCode: 'VOCATIONAL_SKILLS_NOT_BY_TEACHING',
            typeName: 'Jag har kunskaper som jag fått genom yrkeserfarenhet (inte genom läraryrket)',
            yearFreeMax: null,
            yearIntervals: null,
        } : null;
    }

    public static SUBJECT_IS_INCLUDED_IN_EXAMINA(param: IBasisParamterDef): IQualificationBasisDef {
        const valid = param.category === BASIS_CATEGORY_DEF_NAMES.VOCATIONAL;
        return valid ? {
            typeCode: 'SUBJECT_IS_INCLUDED_IN_EXAMINA',
            typeName: 'Ämnet ingår i min behörighetsgivande examen',
            yearFreeMax: null,
            yearIntervals: null,
        } : null;
    }

    private static buildYearIntervals(maxYear: number): string[] {
        if (!maxYear) {
            return null;
        }
        const res: string[] = [];
        if (maxYear === 10) {
            res.push('1-4', '5-7', '8-10');
        } else {
            if (maxYear >= 3) { res.push('1-3'); }
            if (maxYear >= 6) { res.push('4-6'); }
            if (maxYear >= 9) { res.push('7-9'); }
        }
        return res;
    }
}
